import React, { useEffect, useState } from "react";
import Login from "./auth/Login";
import useToken from "../utils/useToken";
import Sections from "./sections/Sections";
import Section from "./sections/Section";
import Templates from "./templates/Templates";
import Reports from './reports/Reports';
import { NavBar } from "./NavBar";
import { Switch, Route } from "react-router-dom";
import { checkUserTokenLogin } from "../utils/checkUser";

const AppWithLogin = () => {
  const { token, setToken } = useToken();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    checkUserTokenLogin(setAllowed);  
  }, [token])
  
  return (
    <div>
      {!allowed || token === null || token === undefined ? (
        <Login setToken={setToken} />
      ) : (
        <>
          <NavBar></NavBar>

          <Switch>
          <Route path="/reports" component={Reports} />

            <Route path="/templates" component={Templates} />

            <Route path="/sections/:id" component={Section} />

            <Route path="/sections" component={Sections} />
          </Switch>
        </>
      )}
    </div>
  );
};

export default AppWithLogin;
